import { GnosisSafe as Connector } from "@web3-react/gnosis-safe";
import { BaseConnectorProps } from "./types";
import {
  useConnectEagerly,
  useConnector,
  useInitializeConnector,
  useSwitchChain,
} from "../hooks";
import { Web3ConnectionType } from "../types";
import { useCallback, useEffect } from "react";

export const GnosisSafe = ({
  onStateUpdate,
  chainId,
  onConnectorUpdate,
  options,
}: BaseConnectorProps<Connector>) => {
  const connector = useInitializeConnector(
    Web3ConnectionType.GNOSIS_SAFE,
    useCallback((actions) => {
      return new Connector({ actions });
    }, []),
  );

  useEffect(() => {
    onConnectorUpdate(connector.connector);
  }, [connector.connector, onConnectorUpdate]);

  const state = useConnector(connector, onStateUpdate);

  useConnectEagerly(connector.connector, Web3ConnectionType.GNOSIS_SAFE);

  useSwitchChain(connector.connector, state, chainId || options.defaultChainId);

  return null;
};
